import { PROPERTY } from "@/data/property";
import { Reveal } from "./Reveal";

export default function Stats() {
  return (
    <section data-testid="stats-section" className="bg-[#0E2A47] relative overflow-hidden">
      <div className="grain-overlay" />
      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
        {PROPERTY.stats.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08}>
            <div className="text-center md:text-left">
              <div className="font-display font-semibold text-4xl md:text-6xl text-white tracking-tight">
                {s.value}
              </div>
              <div className="mt-1 text-sm uppercase tracking-widest text-[#1FB6C9] font-body">
                {s.label}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
